export const getStatusValue = (statusNum: number | undefined): string => {
  if (!statusNum) {
    return 'Disconnected'
  }
  if (statusNum === 1) {
    return 'Connected'
  }
  return 'Pending'
}
